/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useImageOnLoad, useImageProps, useSanityImageCss } from '../../../../../../../../../../../../sanity/utils/image';
import empty from './empty.jpg';
import { useLocalizedSanityTeamMemberByIdFromContext } from '../../../../../../../../../../../../sanity';

const style: ouiStyle.InStyle = {
  position: 'absolute',
  lines: 'full',
  widthLines: 'full',
  borderRadius: 'full',
  overflow: 'hidden',
  backgroundColor: ouiStyle.Constants.Colors.fade,
  objectFit: 'cover',
  aspectRatio: 1,
};

export const TeamMemberProfilePictureContent = () => {
  const {
    data,
  } = useLocalizedSanityTeamMemberByIdFromContext();
  const {
    image,
    firstName,
    lastName,
  } = data ?? {};
  const {
    src,
    srcSet,
    sizes,
    lqip,
    width,
    height,
  } = useImageProps({ image, width: 128 }) ?? {};
  const {
    ref,
    onLoad,
    loaded,
  } = useImageOnLoad();
  const {
    css,
    loaderCss,
  } = useSanityImageCss({
    style,
    loaded,
    hasLqip: lqip != null,
  });
  return (
    <React.Fragment>
      {!loaded
        ? (
          <img
            src={lqip}
            alt={`${firstName} ${lastName}`}
            css={loaderCss}
          />
        )
        : null}
      <img
        ref={ref}
        css={css}
        src={src ?? lqip ?? empty}
        srcSet={srcSet}
        sizes={sizes}
        alt={`${firstName} ${lastName}`}
        onLoad={onLoad}
        loading="lazy"
        decoding="async"
        width={width}
        height={height}
      />
    </React.Fragment>
  );
};
